/* eslint-disable react/jsx-indent-props */
/* eslint-disable react/jsx-first-prop-new-line, react/no-unstable-nested-components */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable max-len, arrow-body-style, no-unused-vars */
import { ArcElement, Chart as ChartJS, Tooltip } from "chart.js";
import { Col, Row } from "react-bootstrap";
import { Pie } from "react-chartjs-2";
import PropTypes from "prop-types";
import { useMemo } from "react";

import {
	emotionImageMap,
	emotionLabels,
	outsideLabelPlugin,
	piechartLabelImages
} from "./helpers/charts";

const EqqoPieChart = ({ className, colors, images, labels, options, scores }) => {
	ChartJS.register(ArcElement, Tooltip);

	const chartData = useMemo(() => scores.map(score => parseFloat(score).toFixed(2) || 0), [scores]);

	const chartOptions = {
		layout : {
			autoPadding: false,
			padding: {
				left: 225,
				right: 225
			}
		},
		plugins: {
			datalabels: {},
			legend: {
				display: false
			},
			outsideLabelPlugin: {
				images: images || piechartLabelImages(emotionLabels, emotionImageMap),
				labels: emotionLabels,
				...options
			},
			tooltip: {}
		},
		responsive: true
	};

	const data = {
		datasets: [
			{
				backgroundColor: colors || ["#E9665B", "#40FFBF", "#B7B6B6", "#FBE652", "#ED61BA", "#7BADF9", "#D09DE5"],
				data: chartData,
			}
		],
		labels: labels || [
			"Anger",
			"Anxiety",
			"Fear",
			"Joy",
			"Love",
			"Sadness",
			"Shame"
		],
		plugins: [outsideLabelPlugin]
	};

	return (
		<Row className={`eqqo-pie-chart | py-3 ${className}`}>
			<Col className="chart">
				<Pie data={data} options={chartOptions} plugins={[outsideLabelPlugin]} />
			</Col>
		</Row>
	);
};

EqqoPieChart.propTypes = {
	className: PropTypes.string,
	colors: PropTypes.arrayOf(PropTypes.string),
	images: PropTypes.arrayOf(PropTypes.string),
	labels: PropTypes.arrayOf(PropTypes.string),
	options: PropTypes.shape({
		distFromCenter: PropTypes.number
	}),
	scores: PropTypes.arrayOf(PropTypes.number).isRequired
};

EqqoPieChart.defaultProps = {
	className: "",
	colors: null,
	images: null,
	labels: null,
	options: {
		distFromCenter: 26
	}
};

export default EqqoPieChart;
